export type AdminSectionId = "produse" | "clienti" | "continut";

export type AdminSectionTab = {
  href: string;
  label: string;
  end?: boolean;
  badgeKey?: string;
};

export type AdminSectionConfig = {
  title: string;
  tabs: AdminSectionTab[];
};

export const ADMIN_SECTION_NAV: Record<AdminSectionId, AdminSectionConfig> = {
  produse: {
    title: "Products",
    tabs: [
      {href: "/vadmin/produse", label: "Products", end: true},
      {href: "/vadmin/produse/recenzii", label: "Reviews", badgeKey: "pendingReviews"},
      {href: "/vadmin/produse/oferte", label: "Offers", badgeKey: "inactiveOffers"},
      {href: "/vadmin/produse/transport", label: "Shipping", badgeKey: "shippingRules"}
    ]
  },
  clienti: {
    title: "Clients",
    tabs: [
      {href: "/vadmin/clienti", label: "Clients", end: true},
      {href: "/vadmin/clienti/grupuri", label: "Groups", badgeKey: "groups"},
      {href: "/vadmin/clienti/notificari", label: "Notifications", badgeKey: "notifications"}
    ]
  },
  continut: {
    title: "Content",
    tabs: [
      {href: "/vadmin/continut", label: "Pages", end: true},
      {href: "/vadmin/continut/carusel", label: "Carousel", badgeKey: "carousel"},
      {href: "/vadmin/continut/anunturi", label: "Announcements", badgeKey: "announcements"},
      {href: "/vadmin/continut/casute", label: "Boxes", badgeKey: "homeBoxes"},
      {href: "/vadmin/continut/faq", label: "FAQ", badgeKey: "faq"}
    ]
  }
};
